import mojangson from 'mojangson';
import nbt from 'prismarine-nbt';
import { fromFormattedString } from '@xmcl/text-component';
import { getItemSelector } from 'minecraft-renderer/src/playerState/playerState';
import { getItemDefinition } from 'mc-assets/dist/itemDefinitions';
export const getItemMetadata = (item, resourcesManager) => {
    let customText = undefined;
    let customModel = undefined;
    let itemId = item.name;
    if (!itemId.includes(':')) {
        itemId = `minecraft:${itemId}`;
    }
    const customModelDataDefinitions = resourcesManager.currentResources?.customItemModelNames[itemId];
    if (item.components) {
        const componentMap = new Map();
        for (const component of item.components) {
            componentMap.set(component.type, component);
        }
        const customTextComponent = componentMap.get('custom_name') || componentMap.get('item_name');
        if (customTextComponent) {
            customText = typeof customTextComponent.data === 'string' ? customTextComponent.data : nbt.simplify(customTextComponent.data);
        }
        const customModelComponent = componentMap.get('item_model');
        if (customModelComponent) {
            customModel = customModelComponent.data;
        }
        if (customModelDataDefinitions) {
            const customModelDataComponent = componentMap.get('custom_model_data');
            if (customModelDataComponent?.data) {
                let customModelData;
                if (typeof customModelDataComponent.data === 'number') {
                    customModelData = customModelDataComponent.data;
                }
                else if (typeof customModelDataComponent.data === 'object'
                    && 'floats' in customModelDataComponent.data
                    && Array.isArray(customModelDataComponent.data.floats)
                    && customModelDataComponent.data.floats.length > 0) {
                    customModelData = customModelDataComponent.data.floats[0];
                }
                if (customModelData && customModelDataDefinitions[customModelData]) {
                    customModel = customModelDataDefinitions[customModelData];
                }
            }
        }
        const loreComponent = componentMap.get('lore');
        if (loreComponent) {
            customText ??= item.displayName ?? item.name;
            // todo test
            customText += `\n${JSON.stringify(loreComponent.data)}`;
        }
    }
    if (item.nbt) {
        const itemNbt = nbt.simplify(item.nbt);
        const customName = itemNbt.display?.Name;
        if (customName) {
            customText = customName;
        }
        if (customModelDataDefinitions && itemNbt.CustomModelData && customModelDataDefinitions[itemNbt.CustomModelData]) {
            customModel = customModelDataDefinitions[itemNbt.CustomModelData];
        }
    }
    return {
        customText,
        customModel
    };
};
export const getItemNameRaw = (item, resourcesManager) => {
    if (!item)
        return '';
    const { customText } = getItemMetadata(item, resourcesManager);
    if (!customText)
        return;
    try {
        if (typeof customText === 'object') {
            return customText;
        }
        const parsed = customText.startsWith('{') && customText.endsWith('}') ? mojangson.simplify(mojangson.parse(customText)) : fromFormattedString(customText);
        if (parsed.extra) {
            return parsed;
        }
        else {
            return parsed;
        }
    }
    catch (err) {
        return {
            text: JSON.stringify(customText)
        };
    }
};
export const getItemModelName = (item, specificProps, resourcesManager, playerState) => {
    let itemModelName = item.name;
    const { customModel } = getItemMetadata(item, resourcesManager);
    if (customModel) {
        itemModelName = customModel;
    }
    const itemSelector = getItemSelector(playerState, {
        ...specificProps
    });
    const modelFromDef = getItemDefinition(appViewer.resourcesManager.currentResources.itemsDefinitionsStore, {
        name: itemModelName,
        version: appViewer.resourcesManager.currentResources.version,
        properties: itemSelector
    })?.model;
    const model = (modelFromDef === 'minecraft:special' ? undefined : modelFromDef) ?? itemModelName;
    return model;
};
